/**
 * Returns true if all tokens are found in content
 *
 * @param content string content to be searched
 * @param input string search input to be tokenized and used to search content
 */
export const containsAllWordsInInput = (content: string, input: string) => {
  if (!input) return true;
  if (!content) return false;

  const searchTokens = input.toLowerCase().trim().split(' ');
  for (const token of searchTokens) {
    if (!content.toLowerCase().includes(token)) {
      return false;
    }
  }
  return true;
};
